<div class="bloco" [formGroup]="dados">
  <!-- Os campos de acesso rápido ficam em cima: o que identifica e o que se negocia. -->
  <div class="sub-section-container">
    <div class="sub-section-title">
      <mat-icon class="material-symbols-outlined">inventory_2</mat-icon>
      <span>Item</span>
    </div>

    <div class="row g-3">
      <div class="col-12 col-md-9">
        <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
          <mat-label>Descrição</mat-label>
          <input matInput formControlName="descricao">
        </mat-form-field>
      </div>

      <div class="col-12 col-md-3">
        <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
          <mat-label>Código (SKU)</mat-label>
          <input matInput formControlName="codigoSku">
        </mat-form-field>
      </div>

      <div class="col-6" [class.col-md-2]="exibeDescontoPorItem" [class.col-md-3]="!exibeDescontoPorItem">
        <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
          <mat-label>Quantidade</mat-label>
          <input matInput formControlName="quantidade" [currencyMask]="mascaraDaQuantidade" class="campo-numero">
        </mat-form-field>
      </div>

      <div class="col-6" [class.col-md-2]="exibeDescontoPorItem" [class.col-md-3]="!exibeDescontoPorItem">
        <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
          <mat-label>Unidade</mat-label>
          <input matInput formControlName="siglaUnidade">
        </mat-form-field>
      </div>

      <!-- Preço de lista e desconto só aparecem com "Exibir campo preço de lista e desconto nos itens"
           ligado (§6.2). Sem ela, o que se negocia é o preço unitário. -->
      @if (exibeDescontoPorItem) {
        <div class="col-6 col-md-2">
          <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
            <mat-label>Preço de lista</mat-label>
            <input matInput formControlName="precoBrutoUnitario" [currencyMask]="mascaraPreco" class="campo-numero">
          </mat-form-field>
        </div>

        <div class="col-6 col-md-2">
          <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
            <mat-label>Desconto (%)</mat-label>
            <input matInput formControlName="descontoPercentual" [currencyMask]="mascaraPercentual" class="campo-numero">
          </mat-form-field>
        </div>
      }

      <div class="col-6" [class.col-md-2]="exibeDescontoPorItem" [class.col-md-3]="!exibeDescontoPorItem">
        <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
          <mat-label>Preço unitário</mat-label>
          <input matInput formControlName="precoLiquidoUnitario" [currencyMask]="mascaraPreco" class="campo-numero">
        </mat-form-field>
      </div>

      <div class="col-6" [class.col-md-2]="exibeDescontoPorItem" [class.col-md-3]="!exibeDescontoPorItem">
        <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
          <mat-label>Preço total</mat-label>
          <input matInput [value]="total | abnt: 'preco' : 2" disabled class="campo-numero">
        </mat-form-field>
      </div>

      <!-- A localização de estoque é do item: a linha nova nasce com o padrão da empresa, e aqui ele se troca. -->
      <div class="col-12 col-md-6">
        <app-select-pesquisavel
          label="Localização"
          [control]="depositoControl"
          [offlineList]="localizacoesEstoque"
          idField="idLocalizacaoEstoque"
          nameField="nome"
          [isOptional]="true"
          [disabled]="isSomenteLeitura"
          subscriptSizing="dynamic"
          [hint]="localizacoesEstoque.length ? '' : 'Nenhuma localização de estoque ativa cadastrada.'"
          placeholder="Selecione...">
        </app-select-pesquisavel>
      </div>

      @if (ehComponenteDeKit) {
        <div class="col-12">
          <app-alert-card type="info" title="Item de um kit">
            Quantidade, preço e descrição vêm do kit e não se alteram no item. Natureza de operação, CFOP e os
            tributos seguem editáveis.
          </app-alert-card>
        </div>
      }

      @if (excedeuOTeto) {
        <div class="col-12">
          <app-alert-card type="warning" title="Desconto acima do limite">
            O desconto efetivo do item passou do limite de {{ tetoDesconto }}% deste perfil. O documento vai pedir
            liberação ao salvar.
          </app-alert-card>
        </div>
      }
    </div>
  </div>

  <div class="sub-section-container">
    <div class="sub-section-title">
      <mat-icon class="material-symbols-outlined">gavel</mat-icon>
      <span>Classificação fiscal</span>
    </div>

    <div class="row g-3">
      <div class="col-12 col-md-6">
        <app-select-pesquisavel
          label="Natureza de operação"
          [control]="naturezaControl"
          [offlineList]="opcoesDeNatureza"
          idField="id"
          nameField="descricao"
          [isOptional]="true"
          emptyOptionLabel="Usar a do documento"
          [disabled]="isSomenteLeitura"
          [hasSuffixAction]="true"
          [hasHintAction]="true"
          subscriptSizing="dynamic"
          placeholder="Selecione...">

          <!-- Dentro da moldura, junto da seta: recarregar a lista é ação do campo (o mesmo do cabeçalho). -->
          <button spSuffix type="button" class="btn-redondo btn-spinner" [class.btn-loading]="isCarregandoNaturezas"
            [disabled]="isCarregandoNaturezas || isSomenteLeitura" (click)="recarregarNaturezas()"
            [attr.aria-label]="isCarregandoNaturezas ? 'Recarregando as naturezas' : 'Recarregar as naturezas do cadastro fiscal'"
            matTooltip="Recarregar as naturezas do cadastro fiscal">
            <mat-icon class="material-symbols-outlined">autorenew</mat-icon>
            @if (isCarregandoNaturezas) { <mat-spinner diameter="16"></mat-spinner> }
          </button>
          <!-- No hint do campo: com natureza abre o cadastro dela; sem, a listagem. -->
          <button spHint type="button" class="vida-link-hint" (click)="abrirNaturezaOperacao()">Ir para a natureza da operação</button>
        </app-select-pesquisavel>
      </div>

      <!-- CFOP guardado cru e exibido com a máscara `0.000`; a pesquisa abre o mesmo diálogo da tela
           de natureza de operação. -->
      <div class="col-6 col-md-3">
        <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
          <mat-label>CFOP</mat-label>
          <input matInput type="text" inputmode="numeric" formControlName="codigoCfop" [mask]="masks.cfop" class="campo-numero">
          @if (!isSomenteLeitura) {
            <button class="icon-mat-symbols-btn" mat-icon-button matSuffix type="button" matTooltip="Pesquisar CFOP"
              (click)="pesquisarCfop()">
              <mat-icon>search</mat-icon>
            </button>
          }
        </mat-form-field>
      </div>

      <div class="col-6 col-md-3">
        <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
          <mat-label>NCM</mat-label>
          <input matInput formControlName="codigoNcm">
        </mat-form-field>
      </div>

      <div class="col-12 col-md-6">
        <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
          <mat-label>Origem da mercadoria</mat-label>
          <mat-select [formControl]="origemControl">
            <mat-option [value]="null">Não informada</mat-option>
            @for (origem of origensMercadoria; track origem.codigo) {
              <mat-option [value]="origem.codigo">{{ origem.descricao }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>

      <div class="col-12 col-md-6">
        <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
          <mat-label>Código do benefício fiscal</mat-label>
          <input matInput formControlName="codigoBeneficioFiscal" maxlength="10">
        </mat-form-field>
      </div>
    </div>
  </div>

  <div class="sub-section-container">
    <div class="sub-section-title">
      <mat-icon class="material-symbols-outlined">notes</mat-icon>
      <span>Informações complementares</span>
    </div>

    <div class="row g-3">
      <div class="col-12">
        <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
          <mat-label>Descrição complementar</mat-label>
          <textarea matInput rows="3" formControlName="descricaoComplementar"
            placeholder="Observação impressa junto ao item"></textarea>
        </mat-form-field>
      </div>

      <div class="col-12 col-md-6">
        <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
          <mat-label>Prazo de disponibilidade (dias)</mat-label>
          <input matInput formControlName="prazoDisponibilidadeDias" [currencyMask]="mascaraInteira" class="campo-numero">
        </mat-form-field>
      </div>
    </div>
  </div>
</div>
